module.exports = __webpack_public_path__ + "static/media/activities.0c1a9aca.svg";